// It's Me — shared helpers: text, song features, maths.
(function () {
  const H = window.HANA = window.HANA || {};
  const TXT = window.HANA_TEXT || {};
  const SONG = window.HANA_SONG;

  H.text = function (key) {
    let v = TXT;
    for (const k of key.split('.')) v = v == null ? v : v[k];
    return v == null ? '' : v;
  };

  H.clamp = (x, a, b) => Math.min(b, Math.max(a, x));
  H.lerp = (a, b, k) => a + (b - a) * k;
  H.smooth = (a, b, x) => { const k = H.clamp((x - a) / (b - a), 0, 1); return k * k * (3 - 2 * k); };
  H.ease = k => k * k * (3 - 2 * k);
  H.mixArr = (a, b, k) => a.map((v, i) => v + (b[i] - v) * k);

  // ---- song features: loudness, four bands, onset; 30 frames a second
  const raw = atob(SONG.bands);
  const F = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) F[i] = raw.charCodeAt(i);
  const CH = 6, FPS = SONG.fps, N = SONG.frames;
  H.duration = SONG.duration;

  H.features = function (t, out) {
    out = out || {};
    const x = H.clamp(t * FPS, 0, N - 1.001);
    const i = Math.floor(x), k = x - i;
    const g = c => (F[i * CH + c] * (1 - k) + F[(i + 1) * CH + c] * k) / 255;
    out.lvl = g(0); out.low = g(1); out.lmid = g(2); out.hmid = g(3); out.air = g(4); out.on = g(5);
    return out;
  };

  // the song's mood, not its drums: features averaged over about a second
  const one = {}, KEYS = ['lvl', 'low', 'lmid', 'hmid', 'air', 'on'];
  H.calm = function (t, out) {
    out = out || {};
    KEYS.forEach(k => { out[k] = 0; });
    let wsum = 0;
    for (let j = -6; j <= 6; j++) {
      const w = 7 - Math.abs(j);
      H.features(t + j * 0.09, one);
      KEYS.forEach(k => { out[k] += one[k] * w; });
      wsum += w;
    }
    KEYS.forEach(k => { out[k] /= wsum; });
    return out;
  };

  // beat pulse: 1 on a beat, decaying
  const B = SONG.beats;
  H.beat = function (t) {
    let lo = 0, hi = B.length - 1;
    if (t < B[0]) return 0;
    while (lo < hi) { const m = (lo + hi + 1) >> 1; if (B[m] <= t) lo = m; else hi = m - 1; }
    const dt = t - B[lo];
    return dt > 1.2 ? 0 : Math.exp(-dt * 7);
  };

  // apply text.js words to [data-t] and aria labels to [data-aria]
  H.applyText = function (root) {
    (root || document).querySelectorAll('[data-t]').forEach(el => { el.textContent = H.text(el.dataset.t); });
    (root || document).querySelectorAll('[data-aria]').forEach(el => { el.setAttribute('aria-label', H.text(el.dataset.aria)); });
  };
})();
